import { render, staticRenderFns } from "./ViewVip.vue?vue&type=template&id=2abafee5&scoped=true&"
import script from "./ViewVip.vue?vue&type=script&lang=js&"
export * from "./ViewVip.vue?vue&type=script&lang=js&"
import style0 from "./ViewVip.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewVip.vue?vue&type=style&index=1&id=2abafee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abafee5",
  null
  
)

export default component.exports